import React from 'react';

const Home = () => {
  const handleImageLoad = (e) => {
    e.currentTarget.classList.add('loaded');
  };

  return (
    <div className='md:px-24 px-4'>
      <div className="relative">

        {/* Main Image with fade + scale animation */}
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745784257/image_57_cg8gsv.png"
          alt="App"
          onLoad={handleImageLoad}
          className="w-full h-auto object-cover transform scale-105 opacity-0 transition-all duration-1000 ease-in-out loaded:scale-100 loaded:opacity-100"
        />

        {/* Play Icon */}
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
          alt="Play"
          className="absolute md:top-[45%] top-[40%] left-[52%] transform -translate-x-1/2 -translate-y-1/2 w-[40px] h-[40px] md:w-[133px] md:h-[133px] z-20 cursor-pointer md:left-[50%]"
        />
        
        {/* Bottom Overlay Content */}
        <div className="absolute bottom-6 left-0 w-full px-4 md:px-6 z-10">
          <h1 className='md:text-[24px] text-white font-semibold text-[10px] tracking-wider'>
            TRAINING
          </h1>

          <div className="relative w-full h-[30px] md:h-[80px] flex items-center justify-between rounded-[10px] text-white border-t-[1px] md:border-t-[3px] border-white">
            <div className="flex flex-col">
              <p className="text-[8px] md:text-[24px] font-normal md:text-left">
                Training Farmers on Poultry <br /> Farming
              </p>
            </div>

            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745784544/image_1713_npu9h0.png"
              alt="QR"
              className="w-[25px] h-[25px] md:w-[60px] md:h-[70px] object-contain"
            />
          </div>
        </div>

        {/* Background Layer */}
        <div className="absolute bottom-6 left-0 right-0 box bg-[#71451F] rounded-[10px] mix-blend-lighten  opacity-90 z-0 h-[30px] md:h-[80px] px-4 md:px-12" />
      </div>
    </div>
  );
};

export default Home;
